import type { CurrentStatus } from '@shared/patient-intake-status';

export const DEFAULT_STATUS_ACTIVITY: CurrentStatus<Record<string, unknown> | null> = {
  status: 'NOT_STARTED',
  actionedAt: null,
  actionedBy: null,
  metadata: null,
  note: null,
};
